var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loadingApp)?[_c('Loading')]:[(_vm.usuarioLogado)?[(_vm.pendencias)?[(_vm.pendencias.atualizar_dados_pessoais)?_c('dialog-atualizar-dados-pessoais'):(_vm.pendencias.documentos.length > 0)?_c('docs-pendentes-ciencia'):_vm._e()]:_vm._e(),_c('Header'),_c('Menu'),_c('Conteudo'),_c('Footer')]:[_c('Auth')]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }